import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	crossButton: {
		cursor : "pointer",
		height : "3rem",
		width  : "3rem"
	},
	header: {
		display              : "flex",
		alignItems           : "center",
		padding              : "1rem 1.5rem",
		borderBottom         : theme.other.darkMode ? "none" : `2px solid ${ theme.other.colors.border.primary }`,
		border               : theme.other.darkMode ? "none" : `1px solid ${ theme.other.colors.border.primary }`,
		justifyContent       : "space-between",
		borderTopLeftRadius  : "1rem",
		borderTopRightRadius : "1rem",
		backgroundColor      : theme.other.colors.dialog.primary
	},
	headerText: {
		fontWeight : "500",
		fontSize   : "1.5rem"
	},
	createPollSection: {
		padding         : "2rem",
		display         : "flex",
		flexDirection   : "column",
		heigt           : "200px",
		gap             : "2rem",
		backgroundColor : theme.other.colors.dialog.secondary

	},
	inputWrapper: {
		display       : "flex",
		flexDirection : "column"
	},
	questionInput: {
		fontSize        : "1.4rem",
		width           : "100%",
		border          : "none",
		borderBottom    : `1px solid ${ theme.other.colors.border.primary }`,
		color           : theme.other.colors.text.primary,
		backgroundColor : "inherit",
		caretColor      : theme.other.paletteNew.primaryDarkBlue,
		"&:focus"       : {
			outline      : "none",
			borderBottom : `1.5px solid ${ theme.other.paletteNew.primaryDarkBlue }`
		}
	},
	inputWordsWrapper: {
		display        : "flex",
		justifyContent : "flex-end",
		fontSize       : "1.4rem",
		color          : "#126bd5"
	},
	optionsWrapper: {
		display       : "flex",
		flexDirection : "column",
		gap           : "1rem"
	},
	optionInput: {
		width           : "100%",
		fontSize        : "1.4rem",
		color           : theme.other.colors.text.primary,
		backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : theme.other.paletteNew.secondaryLightGrey,
		padding         : "1rem",
		borderRadius    : "10px",
		caretColor      : theme.other.paletteNew.primaryDarkBlue
	},
	optioninputinput: {
		backgroundColor : "transparent",
		borderWidth     : "0",
		fontSize        : "1.4rem"
	},
	optionWrapper: {
		padding: "1rem"
	},
	optionIcon: {
		padding: "0 2rem"
	},
	rootInput: {
		padding : "0",
		color   : theme.other.colors.text.primary
	},
	input: {
		padding   : "5px",
		"&:focus" : {
			outline      : "none",
			borderBottom : `1px solid ${ theme.other.paletteNew.primaryDarkBlue }`
		}
	},
	rootInputQuestion: {
		padding  : "0",
		color    : theme.other.colors.text.primary,
		fontSize : "1.4rem"
	},
	fieldStyle: {
		border: "none"
	},
	postPoll: {
		display         : "flex",
		justifyContent  : "center",
		backgroundImage : "linear-gradient(to bottom,#126bd5,#439aff)",
		padding         : "1rem",
		color           : "#fff",
		borderRadius    : "10px",
		cursor          : "pointer",
		opacity         : props?.disablePostButton ? "0.5" : " 1"
	},
	addOptionButton: {
		color        : "#126bd5",
		border       : "1px solid #126bd5",
		textAlign    : "center",
		padding      : "1rem",
		borderRadius : "1rem",
		cursor       : "pointer"
	},
	warningText: {
		color    : theme.other.paletteNew.primaryDarkBlue,
		fontSize : "1.2rem"
	},
	index: {
		color: theme.other.colors.text.primary
	},
	lettersLength: {
		color    : theme.other.paletteNew.primaryDarkBlue,
		fontSize : "1.2rem"
	},
	iconWrapper: {
		display    : "flex",
		alignItems : "center"
	},
	optionFieldWrapper: {
		display       : "flex",
		flexDirection : "column"
	}

} ) );
